module.exports = __webpack_public_path__ + "img/L3.742bf16b.svg";